// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// DocumentType — source: shared/config/document_type.config.json

export const DOCUMENT_TYPE_VALUES = ["bill", "receipt", "bill_and_receipt"] as const;
export type DocumentType = (typeof DOCUMENT_TYPE_VALUES)[number];

